import React, { useContext } from 'react';
import { IconProps } from './iconProps';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import cx from 'classnames';

export default function IconICLogo({
  onClick,
  isAutoscallable = true,
  sizeKey = '32x32',
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconICLogo', { 'icon-disabled': !onClick })}
      onClick={onClick}
      width={w}
      height={h}
      viewBox="0 0 29 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5223 7.29244C27.5879 9.29168 28.1438 11.523 28.1406 13.7885C28.1413 17.4297 26.6996 20.923 24.1311 23.5039L14.3863 33.2414L12.8001 31.6552L22.5375 21.9177C24.1482 20.3047 25.2445 18.2503 25.6879 16.0143C26.1314 13.7783 25.902 11.4611 25.0289 9.3554C24.1558 7.24972 22.678 5.45013 20.7824 4.18405C18.8868 2.91797 16.6584 2.24222 14.3789 2.24222C12.0994 2.24222 9.87101 2.91797 7.97541 4.18405C6.07981 5.45013 4.60206 7.24972 3.72892 9.3554C2.85579 11.4611 2.62644 13.7783 3.06988 16.0143C3.51333 18.2503 4.60965 20.3047 6.22029 21.9177C6.43451 22.1353 6.55567 22.4276 6.5581 22.7329C6.5581 23.0289 6.4405 23.3128 6.23117 23.5222C6.02184 23.7315 5.73792 23.8491 5.44188 23.8491C5.29247 23.8504 5.14437 23.8211 5.00671 23.763C4.86904 23.7049 4.74473 23.6193 4.64145 23.5113C3.03849 21.9103 1.85534 19.9386 1.1969 17.7708C0.538461 15.6031 0.425074 13.3064 0.866804 11.0844C1.30853 8.86234 2.29173 6.78362 3.7292 5.03256C5.16668 3.28149 7.01403 1.91218 9.10743 1.04603C11.2008 0.179885 13.4756 -0.15634 15.7301 0.0671843C17.9846 0.290709 20.149 1.06707 22.0316 2.32742C23.9142 3.58778 25.4567 5.29319 26.5223 7.29244ZM13.7622 8.13036C13.4361 8.34823 13.0527 8.4645 12.6606 8.4645C12.3994 8.46745 12.1403 8.41819 11.8984 8.3196C11.6565 8.221 11.4367 8.07505 11.252 7.89034C11.0673 7.70564 10.9214 7.48589 10.8228 7.244C10.7242 7.00211 10.6749 6.74297 10.6779 6.48177C10.6779 6.08962 10.7941 5.70627 11.012 5.38021C11.2299 5.05414 11.5395 4.80003 11.9018 4.64996C12.2641 4.49989 12.6628 4.46062 13.0474 4.53712C13.432 4.61362 13.7853 4.80246 14.0626 5.07975C14.3399 5.35704 14.5287 5.71033 14.6052 6.09494C14.6817 6.47956 14.6425 6.87823 14.4924 7.24053C14.3423 7.60283 14.0882 7.91249 13.7622 8.13036ZM13.9309 23.0122L14.0794 21.3619C14.6276 21.9236 15.29 22.4366 16.0902 22.8653L16.289 22.9615L16.2591 22.9755H16.3179L16.289 22.9615L16.4941 22.8653C21.3873 20.2402 21.1022 14.452 21.0648 13.6941C21.063 13.6569 21.0618 13.6319 21.0618 13.6199V13.3408L16.3175 11.4942V10.0582L14.2467 9.26514H11.067L8.99609 10.0582V16.0138L10.7512 16.7996L11.3533 23.0122H13.9309ZM12.4038 13.987C12.4038 15.14 12.4552 19.7737 16.3179 21.9694C20.1732 19.7664 20.2613 15.14 20.232 13.987L16.3179 12.4669L12.4038 13.987Z"
        fill="#F5F5F5"
      />
    </svg>
  );
}
